import React from "react";
import { CustomTextField } from "../../../components/TextFields";
import { SelectInput } from "../../../components/inputs/SelectInput";
import { Button } from "@mui/material";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../components/Button";
import { useModal } from "../../../components/modal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Level } from "../../../types/level";
import { getLevelStr } from "../../../utils/level";
import {
  useAddQuizeMutation,
  useUpdateQuizeMutation,
} from "../../../app/services/quize.api";
import { Quize } from "../../../types/quize";
import LoadingButton from "../../../components/Button/LoadingButton";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  desc: yup.string().required("توضیحات الزامی است."),
  level: yup.string().required("سطح آزمون الزامی است."),
  time: yup.number().required("زمان آزمون الزامی است").max(60).min(5),
});
export default function AddModal({
  courseId,
  quize,
}: {
  courseId: string;
  quize?: Quize;
}) {
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    //@ts-ignore
    resolver: yupResolver(schema),
    defaultValues: quize
      ? {
          time: quize.time,
          desc: quize.desc,
          title: quize.title,
          level: quize.level,
        }
      : {},
  });
  const { setShow } = useModal();
  const [addQuize, addState] = useAddQuizeMutation();
  const [editQuize, updateState] = useUpdateQuizeMutation();

  return (
    <React.Fragment>
      <CustomTextField
        required
        label="عنوان"
        placeholder="عنوان را وارد کنید."
        variant="outlined"
        onChange={(e) => setValue("title", e.target.value)}
        defaultValue={getValues("title")}
        error={!!errors.title}
        helperText={errors.title?.message}
      />
      <CustomTextField
        required
        label="توضیحات"
        placeholder="توضیحات را وارد کنید."
        variant="outlined"
        multiline
        minRows={2}
        maxRows={4}
        onChange={(e) => setValue("desc", e.target.value)}
        defaultValue={getValues("desc")}
        error={!!errors.desc}
        helperText={errors.desc?.message}
      />
      <SelectInput
        label="سطح آزمون"
        error={!!errors.level}
        helperText={errors.level?.message}
        onChange={(e) => setValue("level", e?.value as string)}
        defaultValue={{
          label: getLevelStr(getValues("level") as Level) ?? "",
          value: getValues("level") ?? "",
        }}
        options={[
          { label: "مبتدی", value: Level.BEGINNER },
          { label: "متوسط", value: Level.MEDUIM },
          { label: "پیشرفته", value: Level.ADVANCED },
        ]}
      />
      <CustomTextField
        required
        label="زمان"
        placeholder="زمان آزمون را وارد کنید"
        variant="outlined"
        type="number"
        onChange={(e) => setValue("time", Number(e.target.value))}
        defaultValue={getValues("time")}
        error={!!errors.time}
        helperText={errors.time?.message}
      />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading || updateState.isLoading}
          onClick={handleSubmit((data) => {
            const edit = !!quize;
            if (edit) {
              //@ts-ignore
              return editQuize({ courseId, quizeId: quize._id, data: data })
                .unwrap()
                .then(() => setShow(false))
                .catch((err) => {});
            }
            //@ts-ignore
            addQuize({ courseId, data })
              .unwrap()
              .then(() => setShow(false))
              .catch((err) => {});
          })}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
